import React from "react";
import style from "css/workspace.module.css";
import Detailcommon from "./detailcommon";
import Questions from "components/app/questions";
import { useMediaQuery } from "react-responsive";
import SEOMeta from "components/app/SEOMeta";
import { openPopup } from "redux/slices/drawerPopupSlice";
import { useDispatch } from "react-redux";
import NeatPopup from "components/device/neat/neatPopup";

function Reception() {
  //dispatch
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  const HeaderInfo = [
    {
      id: 1,
      txt: (
        <div>
          <font>고객 문의</font> 응답 · <font>방문자</font> 출입 관리 및{"\n"}{" "}
          안내 · <font>예약 관리</font>
        </div>
      ),
      img: "img/smartspace/receptionInfo1.png",
    },
    {
      id: 4,
      txt: (
        <div>
          <font>자동 도어 </font>열림 / 잠금
        </div>
      ),
      img: "img/smartspace/receptionInfo4.png",
    },
    {
      id: 2,
      txt: (
        <div>
          <font>연결 부서 지정</font>하여 상담지원 가능
        </div>
      ),
      img: "img/smartspace/receptionInfo2.png",
    },
    {
      id: 5,
      txt: (
        <div>
          <font>전자 출결 연동</font>하여 근태 관리
        </div>
      ),
      img: "img/smartspace/receptionInfo5.png",
    },
    {
      id: 3,
      txt: (
        <div>
          안내 및 자율좌석
          <font>에약/신청 가능</font>
        </div>
      ),
      img: "img/smartspace/receptionInfo3.png",
    },

    {
      id: 6,
      txt: <div></div>,
      img: "",
    },
  ];

  const BodyInfo = [
    {
      id: 1,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                직원 및 방문객을 쉽고 안전하게 맞이할 수 있으며 사무실 정보,
              </font>
              <font>안전 및 위치 정보를 확인할 수 있습니다.</font>
              <font>
                방문객을 위한 가상 컨시어지 역할을 하고, 리셉셔니스트는 장소에
                구애 받지 않는
              </font>
              <font>근무(유연근무)가 가능해 집니다.</font>
              <font>
                장비(neat.frame)의 메뉴구성을 원하는 대로 구현이 가능합니다.
              </font>
            </>
          ) : (
            "직원 및 방문객을 쉽고 안전하게 맞이할 수 있으며 사무실 정보, 안전 및 위치 정보를 확인할 수 있습니다.\n방문객을 위한 가상 컨시어지 역할을 하고, 리셉셔니스트는 장소에 구애 받지 않는 근무(유연근무)가 가능해 집니다. 장비(neat.frame)의 메뉴구성을 원하는 대로 구현이 가능합니다."
          )}
        </div>
      ),
      title: "리셉셔니스트 시스템\n ( Receptionist )",
      img: "img/smartspace/receptionBody1.png",
      img_m: "img/smartspace/receptionBody1_m.png",
    },
    {
      id: 2,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              {" "}
              <font>
                neat.frame이나 키오스크를 활용하여 자율 좌석존 예약 / 현황
                확인과
              </font>
              <font>회의실 이용이 가능합니다.</font>
            </>
          ) : (
            "neat.frame이나 키오스크를 활용하여 자율 좌석존\n예약 / 현황 확인과 회의실 이용이 가능합니다."
          )}
        </div>
      ),
      title: "자율좌석 예약 시스템\n ( Hot Desking )",
      img: "img/smartspace/receptionBody2.png",
      img_m: "img/smartspace/receptionBody2_m.png",
    },
    {
      id: 3,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              {" "}
              <font>
                기존 사용중인 근태관리 시스템을 연동하여 관리가 가능하며,
              </font>
              <font>출근과 동시에 별도의 로그인 없이</font>
              <font> 자율좌석존 또는 회의실 예약/이용이 가능합니다.</font>
            </>
          ) : (
            "기존 사용중인 근태관리 시스템을 연동하여 관리가 가능하며, 출근과 동시에 별도의 로그인 없이\n자율좌석존 또는 회의실 예약/이용이 가능합니다."
          )}
        </div>
      ),
      title: "근태관리 시스템\n ( Attendance Management )",
      img: "img/smartspace/receptionBody3.png",
      img_m: "img/smartspace/receptionBody3_m.png",
    },
  ];

  const BodyFooter = [
    {
      id: 1,
      txt: "가상 리셉셔니스트는 출입 기록을 디지털로 관리하여 방문자의 출입을 보다 체계적으로 모니터링할 수 있습니다. 방문자는 터치스크린이나 QR 코드를 통해 간편하게 본인 인증을 할 수 있으며, 복잡한 출입 절차 없이 빠르고 안전하게 방문 절차를 완료할 수 있습니다.",
      title: "효율적인 방문자 관리",
    },
    {
      id: 2,
      txt: "인건비를 절감할 수 있으며, 가상 리셉셔니스트가 방문자 응대, 출입 승인, 문의 응답 등을 처리하여 운영의 효율성을 높여줍니다.",
      title: "비용 절감 및 운영 효율성 향상",
    },
    {
      id: 3,
      txt: "방문자와 물리적 접촉 없이도 모든 출입 절차를 처리할 수 있어, 비대면 환경에서도 안전한 방문자 관리가 가능합니다. 자동 도어 제어, 안내문 표시, 실시간 영상 연결 기능 등을 통해 보안을 유지하면서도 방문자와의 소통이 원활합니다.",
      title: "비대면 환경에서의 안전한 방문 관리",
    },
  ];
  const Compose = [
    {
      id: 1,
      img: "img/smartspace/composeImg1.png",
      title: "스마트 워크 플랫폼 all Place",
      txt: "all Place는 회의실/자율좌석 예약 및 관리 플랫폼입니다.\n 사용자가 PC나 모바일을 통해 쉽게 예약할 수 있게 해주며, \n예얀된 내용을 회의실 디스플레이 장비와 실시간으로 동기화됩니다.",
      onClick: () => showDrawer("allplace"),
    },
    {
      id: 2,
      img: "img/device/neat/swiper_frame.png",
      title: "neat. frame",
      txt: "Neat Frame은 간결하면서도 강력한 화상 디바이스로, 가상 \n 리셉셔니스트 역할에 최적화된 장비입니다. 고해상도 디스플레이와 \n 초고화질 카메라를 탑재하여, 방문자와 직원 모두에게 선명하고\n 깨끗한 화면으로 소통할 수 있습니다.",
      onClick: () => showDrawer("frame"),
    },
  ];
  const BodyHeader = (
    <div className={style.bodyTitle}>
      <p>
        가상 리셉셔니스트로 <font>효율적인 공간 관리</font>와{" \n"}
        <font>
          안전한 출입 보장 {!isMobile && !isTablet ? "\n" : " "}장소에 구애받지
          않고{"\n"}
        </font>{" "}
        문의 응답 · 방문 관리 · 근태 관리까지 한 번에
      </p>
    </div>
  );
  const BodyFooterTitle = (
    <div className={style.bodyFooterTitle}>
      {!isMobile && !isTablet ? (
        <>
          {" "}
          <p>
            리브테크놀로지의 <font>가상 리셉셔니스트</font>를 통해
          </p>
          <p>
            <font>스마트한 공간 활용</font>을 실현해보세요
          </p>
        </>
      ) : (
        <>
          <p>
            리브테크놀로지의{"\n"}
            <font>가상 리셉셔니스트</font>를 통해
          </p>
          <p>
            <font>스마트한 공간 활용</font>을 실현해보세요
          </p>
        </>
      )}
    </div>
  );
  const ComposeHeader = (
    <div className={style.commonComposeTitle}>
      가상 리셉셔니스트 <font>구성 환경</font>
    </div>
  );
  const showDrawer = (menu) => {
    dispatch(
      openPopup({
        type: menu,
      })
    );
    document.querySelector("#page_header").style.height = "0";
  };
  return (
    <>
      <SEOMeta
        title="가상 리셉셔니스트, 리브테크놀로지"
        description="리브테크놀로지 riv Technolohy - 가상 리셉셔니스트"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, 스마트 회의실, 화상회의, 가상 리셉셔니스트"
      />
      <NeatPopup />
      <div className={style.wrapper}>
        <div className={style.commonHeader}>
          <div className={style.CommonHeaderTxt}>
            <p>Video and Virtual Receptionist</p>
            <p>가상 리셉셔니스트</p>
            <p>
              <font>
                {"리셉셔니스트를 통해 직원과\n 게스트를 쉽고 안전하게 맞이하고"}
              </font>
              <font>
                {
                  "리셉셔니스트가 장소에 구애 받지 않고\n 일하는 것도 가능 합니다."
                }
              </font>
            </p>
          </div>
          <img
            alt=""
            src={
              !isMobile && !isTablet
                ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/receptionHeader.png`
                : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/receptionHeader_m.png`
            }
          />
          <div className={style.receptionHeaderInfoWrap}>
            {!isMobile && !isTablet
              ? HeaderInfo.map(
                  (info, idx) =>
                    info.id !== 6 && (
                      <div className={style.receptionHeaderInfo} key={idx}>
                        <div className={info.id === 6 ? style.none : ""}>
                          <img
                            alt=""
                            src={
                              `${process.env.REACT_APP_CLIENT_URL}` + info.img
                            }
                          />
                        </div>
                        {info.txt}
                      </div>
                    )
                )
              : HeaderInfo.sort((a, b) => a.id - b.id).map(
                  (info, idx) =>
                    info.id !== 6 && (
                      <div className={style.receptionHeaderInfo} key={idx}>
                        <div className={info.id === 6 ? style.none : ""}>
                          <img
                            alt=""
                            src={
                              `${process.env.REACT_APP_CLIENT_URL}` + info.img
                            }
                          />
                        </div>
                        {info.txt}
                      </div>
                    )
                )}
          </div>
        </div>

        <Detailcommon
          bodyHeader={BodyHeader}
          bodyInfo={BodyInfo}
          bodyFooter={BodyFooter}
          compose={Compose}
          bodyFooterTitle={BodyFooterTitle}
          composeHeader={ComposeHeader}
        />
        <Questions />
      </div>
    </>
  );
}

export default Reception;
